import DIApi from './_diApi';

class HamletAPI extends DIApi {
  controllerName = 'Hamlets';
}

export default new HamletAPI();
